// extracted by mini-css-extract-plugin
export default {"IDNowModal":"IDNowModal_IDNowModal","title":"IDNowModal_title","description":"IDNowModal_description","continueToIDNow":"IDNowModal_continueToIDNow buttons_button"};